module.exports = __webpack_public_path__ + "img/kp-tj.38cbd90d.png";